// Codes that are baked into external partner links we can't get changed.
// Auto-applying them now just shows the user a red "invalid coupon" error, so we skip them.
const EXPIRED_VOUCHER_CODES = [
  'VIPOMEN',
  'OMENVIP',
  'OMENJULY',
  'OMENSEPT',
];

export function normaliseVoucherCode(code) {
  return String(code || '').trim().toUpperCase();
}

export default function isExpiredVoucherCode(code) {
  if (!code) return false;
  return EXPIRED_VOUCHER_CODES.includes(normaliseVoucherCode(code));
}
